import {ContactRelationship, SchoolClass} from "models"
import Cycler, {colors} from "shared/cycler"
import {memo, PropTypes, propTypesExact, ShapeComponent, shapeComponent} from "shared/base"
import Modal from "components/modal"
import React from "react"
import useCollection from "@kaspernj/api-maker/build/use-collection"
import useI18n from "i18n-on-steroids/src/use-i18n.mjs"
import UserCircle from "components/school-class-roles/user-circle"
import {View} from "react-native"

export default memo(shapeComponent(class RoutesUserAdminSchoolClassesRolesIndex extends ShapeComponent {
  static propTypes = propTypesExact({
    onRequestClose: PropTypes.func.isRequired,
    schoolClass: PropTypes.instanceOf(SchoolClass).isRequired
  })

  setup() {
    const {t} = useI18n({namespace: "js.routes.user.admin.school_classes.roles.index"})
    const {schoolClass} = this.p
    const {contactRelationships} = useCollection({
      abilities: {
        ContactRelationship: ["destroy"]
      },
      modelClass: ContactRelationship,
      preloads: ["child.user", "contact_relationship_type"],
      ransack: {
        parent_school_class_id_eq: schoolClass.id()
      },
      select: {
        Contact: ["id"],
        ContactRelationship: ["id"],
        ContactRelationshipType: ["id", "identifier", "translatedIdentifier"],
        User: ["color", "initials", "name"]
      }
    })

    this.setInstance({
      colorCycler: new Cycler(colors),
      contactRelationships,
      t
    })
  }

  render() {
    const {colorCycler, contactRelationships, t} = this.tt
    const {onRequestClose} = this.p

    return (
      <Modal
        dataSet={this.modalDataSet ||= {route: "user/dashboard/school-class-roles-modal"}}
        onRequestClose={onRequestClose}
        title={t(".users_on_your_school")}
      >
        <View style={this.userCirclesViewStyle ||= {display: "flex", flexDirection: "row", flexWrap: "wrap"}}>
          {contactRelationships?.map((contactRelationship) =>
            <UserCircle
              backgroundColor={contactRelationship.child().user().color() || colorCycler.cycle()}
              key={contactRelationship.id()}
              schoolClassRole={contactRelationship}
              style={this.userCircleStyle ||= {marginRight: 10, marginBottom: 10}}
            />
          )}
        </View>
      </Modal>
    )
  }
}))
